export default {
    open_in_maps: 'Open in maps',
    go_to_profile: 'Go to profile',
    offer_count: '1 service | {n} services',
    your_location: 'Your location',
    copy_address: 'Location',
}
